import PropTypes from 'prop-types';
import React from 'react';

import { WHITE } from '@wetransfer/transfer/constant/colors';

const Apple = ({ width, color }) => (
  <svg width={width} height={width} viewBox="78 0 32 39">
    <path
      fill={color}
      fillRule="evenodd"
      d="M99.63 6.066c.984-1.67 1.937-3.858 1.73-6.066-1.992.07-4.318 1.256-6.05 2.6-.9 1.638-1.984 3.914-1.727 6.066 2.176.126 4.358-1.075 6.048-2.6zm6.05 18.2c-.784-1.27-1.068-3.203-.864-5.2.287-1.68 1.63-3.78 2.592-4.334.123-.218.137-.228 0 0 .393-.503 1.07-1.04 1.728-1.733-1.89-2.084-4.66-3.406-7.777-3.467-2.55-.217-5.502 1.792-6.913 1.733-1.72.06-4.048-1.754-6.912-1.733.33.09-.112.114 0 0-3.366.193-6.25 2.082-7.777 5.2-.77.777-1.547 3.182-1.728 4.332v.867c-.09.552.06 3.126 0 4.333.244.053.246.075 0 0 .39 1.324 1.025 3.708 1.728 5.2.23.973 1.508 3.39 2.592 4.332 1.42 2.66 3.382 5.31 6.05 5.2 2.422-.097 3.342-1.64 6.047-1.734 3.318.094 4.15 1.657 6.912 1.734 2.566-.18 4.233-2.537 6.048-5.2.67-.916 1.952-3.257 2.592-4.333-.13-.46-.054-.687 0-.866-1.77-.48-3.753-2.774-4.32-4.333z"
    />
  </svg>
);

Apple.propTypes = {
  color: PropTypes.string,
  width: PropTypes.number,
};

Apple.defaultProps = {
  color: WHITE,
  width: 39,
};

export default Apple;
